import axios from 'axios'
import {store} from '../lib/store'

axios.interceptors.response.use(function (response) {
	// Any status code that lie within the range of 2xx cause this function to trigger
	// Do something with response data
	return response
}, function (error) {
	// Any status codes that falls outside the range of 2xx cause this function to trigger
	// Do something with response error

	// Retry
	if (error.message == 'Network Error') {

		if (api.attempt <= api.maxAttempts) {
			var config = error.config

			if (api.debug > 1) {
				console.log('-- retry connection to ' + error.config.url)
				console.log('-- attempt: ' + api.attempt)
				console.log(error.config)
			}
			api.attempt = api.attempt + 1

			/*
				время между попытками растет по экспоненте
				0,37 сек между 1 и 2 попытками
				1,00 сек между 2 и 3 попытками
				2,72 сек между 3 и 4 попытками
				7,39 сек между 4 и 5
				20,09 сек между 5 и 6
				54,60 сек между 6 и 7
				2 мин 28 сек между 7 и 8
				6 мин 43 сек между 8 и 9
				18 мин 16 сек между 9 и 10
				49 мин 41 сек между 10 и 11
				2 часа 15 мин между 11 и 12
				6 часов 7 мин между 12 и 13
				16 часов 37 мин между 13 и 14
				45 часов 12 мин между 14 и 15
			*/

			let delay = Math.exp(api.attempt - 3) * 1000

			return new Promise(function (resolve) {
				return setTimeout(function () {
					return resolve(axios(config))
				}, delay)
			})
		}
		else {
			if (this.debug > 1) {
				console.log('-- max retry attempts reached')
				console.log('-- end up calling ' + error.config.url)
			}
		}
	}

	return Promise.reject(error)
})

export const api = {
	// debug setup
	// 0 - нет
	// 1 - только запрос без параметров
	// 2 - запрос и ответ с параметрами
	debug: 0,
	attempt: 1, // номер попытки соединения
	maxAttempts: 15, // максимальное количество попыток соединения
	path: function() {
		let protocol = window.location.protocol	// 'http:' или 'https:'

		if (store.getters.env == 'development') {
			return protocol + '//dev-api-reports.ifk-hm.com/'
		}
		else if (store.getters.env == 'production') {
			return protocol + '//api-reports.ifk-hm.com/'
		}
		else {
			return ''
		}
	},
	checkLocal: function() {
		if (store.state.token && store.state.token.exp) {
			var exp = store.state.token.exp
		}
		else {
			return false
		}

		let time = parseInt(new Date().getTime()/1000)

		if (time > exp) {
			return false
		}
		else {
			return true
		}
	},
	all: function(...args) {
		return axios.all(...args)
	},
	spread: function(...args) {
		// console.log(...args)
		return axios.spread(...args)
	},
	post: function(...args) {
		if (this.debug > 0) {
			console.log('>> api ' + args[0])
			if (this.debug > 1) {
				if (args[1]) console.log(args[1])
				console.log('------')
			}
		}

		axios.defaults.baseURL = this.path()

		// перед каждым запросом читаем токен из localStorage
		// т.к. в соседней вкладке могли обновить токены в localStorage
		// и сделать хранимые в store токены недействительными

		if (store.getters.tokenReadTime < Math.floor(Date.now() / 1000) - 60) {
			store.commit('getTokenFromStorage')
		}

		if (!this.checkLocal()) {
			axios.defaults.headers.common['authorization'] = 'expired';
		}

		if (args[1] instanceof FormData) {
			args.push({
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
		}

		return axios.post(...args)
		.then(response => {
			if (this.debug > 1) {
				console.log('<< api ' + args[0])
				if (args[1]) console.log(args[1])
				console.log(response.data)
				console.log('------')
			}

			if (response.data.token !== undefined) {
				if (this.debug > 1) console.log('-- update token')
				store.commit('updateToken', response.data.token)
				delete response.token
			}

			if (!response.data) {
				throw new Error('Server did not reply')
			}

			if (typeof response.data.success == 'undefined') {
				throw new Error(response.data)
			}

			if (!response.data.success) {
				if (this.debug > 1) console.log('-- response error')
				if (this.debug > 1) console.log('-- ' + response.data.error)

				if (response.data.error == 'Unauthorized' || response.data.error == 'Restricted') {
					if (this.debug > 1) console.log('-- logout')
					store.commit('authLogout')
				}
				else if (response.data.error) {
					throw new Error(response.data.error)
				}
				else {
					throw new Error('Неизвестная ошибка')
				}
			}

			else {
				return response
			}
		})
		.catch(error => {
			if (error.message == 'Network Error') {

				if (this.debug > 1) {
					console.log(error)
					console.log(error.response)
					console.log(error.request)
					console.log(error.message)
				}

			}
			else {
				var message

				if (store.getters.env == 'development') {
					message = '<p>Address: ' + args[0] + '</p><p>' + error.message + '</p>'
				}
				else {
					message = '<p>' + error.message + '</p>'
				}

				store.dispatch('dialogNotify', {
					title: 'Что-то пошло не так',
					message: message
				})
				throw new Error(error.message)
			}
		})
	}
}
